module.exports = __webpack_public_path__ + "img/jaoc_pizzagame_black-toppings.50871121.png";